import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPostInfo } from '../../actions/userActions';
import CampaignsView from '../../containers/Profile/Campaigns/Campaigns';
import * as Yup from "yup";
import { createCampaign } from '../../admin/actions/campaignActions';

const Campaigns = ({ match,history}) => {
    const dispatch = useDispatch();
    const { postInfo ,userInfo} = useSelector(state => state.userInfo)
    useEffect(() => {
        dispatch(getPostInfo(match.params.postId))
    }, [match.params.postId])

    const validationSchema = Yup.object().shape({
        likePoints: Yup.number().positive("no puede ser negativo").required("Es requerido")
            .when(['likePointsTotalPoints',"likeEcos"], (total,ecos, schema) => {
                return schema.test("test-name", "Debe ser menor y divisible por el total",
                    (points) => total % (points+ecos) === 0 && total <= (points+ecos))
            }),
        commentPoints: Yup.number().positive("no puede ser negativo").required("Es requerido")
            .when(['commentPointsTotalPoints',"commentEcos"], (total,ecos, schema) => {
                return schema.test("test-name", "Debe ser menor y divisible por el total",
                    (points) => total % (points+ecos)  === 0 && total <= (points+ecos))
            }),
        sharePoints: Yup.number().positive("no puede ser negativo").required("Es requerido")
            .when(['sharePointsTotalPoints',"shareEcos"], (total,ecos, schema) => {
                return schema.test("test-name", "Debe ser menor y divisible por el total",
                    (points) => total % (points+ecos)  === 0 && total <= (points+ecos) )
            }),

        likePointsTotalPoints: Yup.number().positive("no puede ser negativo").required("Es requerido"),
        commentPointsTotalPoints: Yup.number().positive("no puede ser negativo").required("Es requerido"),
        sharePointsTotalPoints: Yup.number().positive("no puede ser negativo").required("Es requerido"),
    });
    const formik = useFormik({
        initialValues: {
            likePoints: 0,
            commentPoints: 0,
            sharePoints: 0,

            likeEcos: 0,
            commentEcos: 0,
            shareEcos: 0,

            likePointsTotalPoints: 0,
            commentPointsTotalPoints: 0,
            sharePointsTotalPoints: 0,
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {

            const data = {
                postId: postInfo[0]._id,
                entityId: userInfo.franchiseID._id,
                dataToPoints: {
                    likePoints: {
                        value: values.likePoints,
                        ecos: values.likeEcos,
                        totalPoints: values.likePointsTotalPoints
                    },
                    commentPoints: {
                        value: values.commentPoints,
                        ecos: values.commentEcos,
                        totalPoints: values.commentPointsTotalPoints
                    },
                    sharePoints: {
                        value: values.sharePoints,
                        ecos: values.shareEcos,
                        totalPoints: values.sharePointsTotalPoints
                    }
                }
            }
            dispatch(createCampaign(data,history))
            
        }
    })
    return <CampaignsView post={postInfo[0]} formik={formik} />
};

export default Campaigns;
